import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { KartePlannerCommentFormAvailabilityFragmentDoc, KartePlannerCommentFormViewerFragmentDoc } from './KartePlannerCommentForm.generated';
import { KartePlannerCommentMonthlyAmountFragmentDoc } from '../KartePlannerCommentMonthlyAmount/KartePlannerCommentMonthlyAmount.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchKarteUserDetailViewQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FetchKarteUserDetailViewQuery = { __typename?: 'Query', karte: { __typename?: 'Karte', kartePlannerCommentAvailability: { __typename?: 'KartePlannerCommentAvailability', availability: boolean, unavailableReason?: Types.KartePlannerCommentUnavailableReason | null }, ownKartePlannerComment?: { __typename?: 'KartePlannerComment', comment?: string | null, selections?: Array<string> | null } | null, user: { __typename?: 'User', livingPrefecture?: Types.Prefecture | null, birthYear?: number | null, gender: Types.UserGender, numberOfMatch: number, address?: { __typename?: 'UserAddress', prefecture: string, city: string } | null } }, viewer: { __typename?: 'Viewer', plan: Types.Plan } };

export type PostKartePlannerCommentMutationVariables = Types.Exact<{
  karteID: Types.Scalars['ID']['input'];
  comment: Types.Scalars['String']['input'];
  selections?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type PostKartePlannerCommentMutation = { __typename?: 'Mutation', postKartePlannerComment: { __typename?: 'PostKartePlannerCommentMutationErrorPayload', error: Types.KartePlannerCommentUnavailableReason } | { __typename?: 'PostKartePlannerCommentMutationSuccessPayload', karte: { __typename?: 'Karte', id: string, numberOfPlannerComments: number, isLikelyToMatch: boolean, hasCommentsFromPlannersBelongingToSameBranch: boolean, kartePlannerCommentAvailability: { __typename?: 'KartePlannerCommentAvailability', availability: boolean, unavailableReason?: Types.KartePlannerCommentUnavailableReason | null }, ownKartePlannerComment?: { __typename?: 'KartePlannerComment', id: string, comment?: string | null, selections?: Array<string> | null } | null }, viewer: { __typename?: 'Viewer', id: string, kartePlannerCommentMonthlyAmount: { __typename: 'ManageOnlyFreePlanKartePlannerCommentMonthlyAmount' } | { __typename: 'V2021_1KartePlannerCommentMonthlyAmount', items: Array<{ __typename?: 'V2021_1KartePlannerCommentMonthlyAmountItem', channel: Types.Channel, usage: number, upperLimit?: number | null }> } | { __typename: 'V2022_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit?: number | null } | { __typename: 'V2023_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit?: number | null } } } };


export const FetchKarteUserDetailViewDocument = gql`
    query FetchKarteUserDetailView($id: ID!) {
  karte(id: $id) {
    kartePlannerCommentAvailability {
      ...KartePlannerCommentFormAvailability
    }
    ownKartePlannerComment {
      comment
      selections
    }
    user {
      livingPrefecture
      birthYear
      gender
      address {
        prefecture
        city
      }
      numberOfMatch
    }
  }
  viewer {
    ...KartePlannerCommentFormViewer
  }
}
    ${KartePlannerCommentFormAvailabilityFragmentDoc}
${KartePlannerCommentFormViewerFragmentDoc}`;

/**
 * __useFetchKarteUserDetailViewQuery__
 *
 * To run a query within a Vue component, call `useFetchKarteUserDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchKarteUserDetailViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchKarteUserDetailViewQuery({
 *   id: // value for 'id'
 * });
 */
export function useFetchKarteUserDetailViewQuery(variables: FetchKarteUserDetailViewQueryVariables | VueCompositionApi.Ref<FetchKarteUserDetailViewQueryVariables> | ReactiveFunction<FetchKarteUserDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>(FetchKarteUserDetailViewDocument, variables, options);
}
export function useFetchKarteUserDetailViewLazyQuery(variables?: FetchKarteUserDetailViewQueryVariables | VueCompositionApi.Ref<FetchKarteUserDetailViewQueryVariables> | ReactiveFunction<FetchKarteUserDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>(FetchKarteUserDetailViewDocument, variables, options);
}
export type FetchKarteUserDetailViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>;
export const PostKartePlannerCommentDocument = gql`
    mutation postKartePlannerComment($karteID: ID!, $comment: String!, $selections: [String!]) {
  postKartePlannerComment(
    karteID: $karteID
    comment: $comment
    selections: $selections
  ) {
    ... on PostKartePlannerCommentMutationErrorPayload {
      error
    }
    ... on PostKartePlannerCommentMutationSuccessPayload {
      karte {
        id
        kartePlannerCommentAvailability {
          ...KartePlannerCommentFormAvailability
        }
        ownKartePlannerComment {
          id
          comment
          selections
        }
        numberOfPlannerComments
        isLikelyToMatch
        hasCommentsFromPlannersBelongingToSameBranch
      }
      viewer {
        id
        kartePlannerCommentMonthlyAmount {
          ...KartePlannerCommentMonthlyAmount
        }
      }
    }
  }
}
    ${KartePlannerCommentFormAvailabilityFragmentDoc}
${KartePlannerCommentMonthlyAmountFragmentDoc}`;

/**
 * __usePostKartePlannerCommentMutation__
 *
 * To run a mutation, you first call `usePostKartePlannerCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePostKartePlannerCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePostKartePlannerCommentMutation({
 *   variables: {
 *     karteID: // value for 'karteID'
 *     comment: // value for 'comment'
 *     selections: // value for 'selections'
 *   },
 * });
 */
export function usePostKartePlannerCommentMutation(options: VueApolloComposable.UseMutationOptions<PostKartePlannerCommentMutation, PostKartePlannerCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PostKartePlannerCommentMutation, PostKartePlannerCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PostKartePlannerCommentMutation, PostKartePlannerCommentMutationVariables>(PostKartePlannerCommentDocument, options);
}
export type PostKartePlannerCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PostKartePlannerCommentMutation, PostKartePlannerCommentMutationVariables>;